import i18n, { Resource } from "i18next";
import { initReactI18next } from "react-i18next";

import en from "./en";
import ko from "./ko";

const langCd = "ko";

const resources: Resource = {
  en: {
    translation: en,
  },
  ko: {
    translation: ko,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: `${langCd}`,
  // lng: "ko",
  fallbackLng: "en",

  interpolation: {
    escapeValue: false, // React에서는 보통 false 설정
  },
});

export default i18n;
